'use client';
import { useSyncExternalStore } from 'react';
import type { ReactNode } from 'react';
import { getRoiFormHref, getRoiFormHrefServer, subscribeRoiFormHref } from './roi-href-store';

const Arrow = () => (
  <svg viewBox="0 0 20 20" aria-hidden fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M4 10h11M11 5l5 5-5 5" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

/**
 * A plain <a> (CtaTagger adds ?cta=<data-cta> at click time) whose href follows the player's numbers once the calculator has
 * mounted. Server HTML carries the base link, so the button works with no JavaScript.
 */
export function RoiFormLink({ cta, className, children, arrow = true }: { cta: string; className?: string; children: ReactNode; arrow?: boolean }) {
  const href = useSyncExternalStore(subscribeRoiFormHref, getRoiFormHref, getRoiFormHrefServer);
  return (
    <a href={href} data-cta={cta} className={className}>
      <span>{children}</span>
      {arrow && <Arrow />}
    </a>
  );
}
